/* libs */
import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";

class SimpleTextInput extends Component {
	constructor(props) {
		super(props);
		this.state = {
			minimizePlaceholder: false,
		};
	}

	onFocus = () => {
		this.setState({
			minimizePlaceholder: true,
		});
	};

	onBlur = value => {
		if (!value || value.length < 1) {
			this.setState({
				minimizePlaceholder: false,
			});
		}
	};

	render() {
		const { placeholder, helperText, isRequired, value, error } = this.props;
		const { minimizePlaceholder } = this.state;
		const isFocused = minimizePlaceholder ? " focus" : "";
		const hasError = error ? " has-error" : "";

		if (value && (value.length > 0 || typeof value === "number") && minimizePlaceholder === false) {
			this.setState({
				minimizePlaceholder: true,
			});
		}
		var propsToPass = Object.assign({}, this.props);
		if (propsToPass.placeholder) {
			delete propsToPass.placeholder;
		}

		return (
			<Fragment>
				<div className={`input-wrap${isFocused}${hasError}`}>
					<div className="input-box-wrap">
						<div className="placeholder">
							<span className={minimizePlaceholder ? "caption-text" : ""}>
								{isRequired && <span className="isrequired-label">*</span>}
								{placeholder}
							</span>
						</div>
						<div className="input-box">
							<input
								placeholder={placeholder}
								onFocus={() => this.onFocus()}
								onBlur={evt => this.onBlur(evt.target.value)}
								{...propsToPass}
								autoComplete={this.props.autocomplete ? this.props.autocomplete : null}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-xs-6">
							<div className="caption-text helper-message">{helperText}</div>
						</div>
						<div className="col-xs-6">
							<div className="error-message caption-text">{error ? error : ""}</div>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

SimpleTextInput.propTypes = {
	field: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	type: PropTypes.string,
	helperText: PropTypes.string,
	value: PropTypes.string,
	error: PropTypes.string,
	fieldState: PropTypes.object,
};

export default SimpleTextInput;
